var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-container"},[_c('div',{staticClass:"left-box"},[_c('el-button',{attrs:{"icon":"el-icon-menu","size":"mini"},on:{"click":_vm.handleMenu}})],1),_c('div',{staticClass:"right-box"},[_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":_vm.outLand}},[_vm._v("退出登录")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }